import React from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { SvgIconComponent } from '@mui/icons-material'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { ConfigItem } from './ConfigLine'
import { ConfigList } from './ConfigList'

interface ConfigAccordionProps {
  title: string
  description?: string
  icon?: SvgIconComponent
  items: ConfigItem[]
  onSave: (item: ConfigItem, newValue: string) => Promise<boolean>
}

export const ConfigAccordion = ({
  title,
  description,
  icon: Icon = SettingsOutlinedIcon,
  items,
  onSave
}: ConfigAccordionProps) => {
  return (
    <Accordion
      disableGutters
      defaultExpanded
      sx={{
        mb: 1,
        borderRadius: '12px !important',
        overflow: 'hidden',
        boxShadow: '0px 1px 4px rgba(0,0,0,0.08)',
        '&:before': { display: 'none' }
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ px: 3, py: 1.5, borderRadius: '12px' }}
      >
        <Box display='flex' alignItems='center' gap={2} width='100%'>
          <Box
            sx={{
              bgcolor: 'primary.50',
              borderRadius: 2,
              p: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Icon fontSize='small' color='primary' />
          </Box>
          <Box flex={1}>
            <Typography variant='body1' fontWeight={500}>
              {title}
            </Typography>
            {description && (
              <Typography variant='caption' color='text.secondary'>
                {description}
              </Typography>
            )}
          </Box>
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 0 }}>
        {items.length > 0 ? (
          <ConfigList items={items} onSave={onSave} />
        ) : (
          <Typography textAlign='center' variant='body2' color='text.secondary' py={2}>
            Sin parámetros de configuración
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
  )
}
